import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/googleAnalytics';

/**
 * React Hook für automatisches Page View Tracking
 * Wird in der App-Komponente eingebunden
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view bei jedem Seitenwechsel
    trackPageView(location.pathname + location.search);
  }, [location]);
};
